export default __webpack_public_path__ + "static/media/IMG_20230508_214339_824.37884e59.jpg";